/**
 * Returns true if all required fields have non-empty values.
 * Alerts the user with a list of missing fields if not.
 *
 * @param {Array<[value, string]>} fields - pairs of [value, label]
 */
export function requireFields(fields) {
  const missing = fields
    .filter(([v]) => !String(v ?? '').trim())
    .map(([, label]) => label);
  if (missing.length) {
    window.alert(`Please provide:\n- ${missing.join('\n- ')}`);
    return false;
  }
  return true;
}

/**
 * Returns true if the date range is valid.
 * Alerts the user if end is before start.
 */
export function validateDateRange(start, end, endLabel = 'End Date') {
  if (start && end && end < start) {
    window.alert(`${endLabel} must be on or after Start Date.`);
    return false;
  }
  return true;
}
